import { useState, useEffect } from 'react';
import { axiosApi } from '../../api/setupApi';

const useGetYears = (section = 'bohol') => {
  const [years, setYears] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getBaseCandidates = (targetSection) => {
    if (targetSection === 'siquijor') {
      return ['cisSiquijor', 'cissiquijor', 'cisSiquijior', 'cissiquijior'];
    }
    return ['cisBohol', 'cisbohol'];
  };

  const fetchYears = async () => {
    setLoading(true);
    setError(null);

    const bases = getBaseCandidates(section);
    let lastError = null;

    for (const base of bases) {
      try {
        const { data } = await axiosApi.get(`/${base}/years`);
        console.log('API Response:', data);
        let yearList = [];
        if (Array.isArray(data)) {
          yearList = data
            .map(item => (typeof item === 'object' && item.years ? item.years : item))
            .filter(year => typeof year === 'number' && !isNaN(year))
            .sort((a, b) => b - a);
        } else if (data && Array.isArray(data.years)) {
          yearList = data.years
            .filter(year => typeof year === 'number' && !isNaN(year))
            .sort((a, b) => b - a);
        }
        // Ensure current year is included if the list is empty
        const currentYear = new Date().getFullYear();
        if (yearList.length === 0) {
          yearList = [currentYear];
        } else if (!yearList.includes(currentYear)) {
          yearList.unshift(currentYear); // Prioritize current year
        }
        console.log('Processed yearList:', yearList);
        setYears(yearList);
        setLoading(false);
        return;
      } catch (err) {
        lastError = err;
      }
    }

    setError(lastError?.response?.data?.error || lastError?.message || 'Failed to fetch years');
    setLoading(false);
  };

  useEffect(() => {
    fetchYears();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section]);

  return { years, loading, error, refetch: fetchYears };
};

export default useGetYears;